export const formatRateUnit = (unit: string | undefined): string => {
  if (unit === "year") {
    return "year";
  }
  if (unit === "quarter") {
    return "quarter";
  }
  if (unit === "month") {
    return "month";
  }
  if (unit === "week") {
    return "week";
  }
  if (unit === "day") {
    return "day";
  }
  if (unit === "hour") {
    return "hr";
  }
  if (unit === "minute") {
    return "min";
  }
  if (unit === "second") {
    return "sec";
  }
  return unit ?? "";
};
